class EnterPickupController {
    /*@ngInject*/
    constructor($log, ProductDetailService) {
        $log.debug('EnterPickupController initialized');
        this.$log = $log;
        this.productDetailService = ProductDetailService;
    }

    doEnter($event) {
        let selectedVariant = this.productDetailService.getVariantData();
        if (selectedVariant == null) {
            this.productDetailService.setWarningSelectSize(true);
            return;
        }

        let pickupUrl = $($event.currentTarget).data('href');
        window.location = pickupUrl + '?productCode=' + selectedVariant.code;
    }

}

export default EnterPickupController;
